// 完成した画像のダウンロード・保存データの埋め込み（2026-10-21 に app.js から分けた）
import { S } from './state.js';
import { txtHtml } from './text.js';
import { $ } from './util.js';
import { saveObject } from './core/savedata.js';
import { zip } from './core/zlib.js';
import { embedText } from './core/embed.js';

// ダウンロード: 完成の画面の画像そのまま（背景・キャラ・名前・(C) CHARAT）を白地 800px に。キャラの保存データを埋め込む
// （あとでこの画像から復元できる。埋め込み方は core/embed.ts。additional.js の画像DL と同じもの）。
// 本物の imageDL は背景と名前が入らない（#chaSvgSave だけを描く）ので、モックは見えているものを保存する
export function randomName() {
  let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789', s = '';
  for (let i = 0; i < 10; i++) s += chars.charAt(Math.floor(Math.random() * chars.length));
  return s;
}
// kind: 'white'（白い背景）か 'clear'（透明な背景）。それ以外（ボタンのクリック）なら選ぶ画面を出す（2026-10-16。以前は白い背景だけ）
export function downloadFinished(kind?: unknown) {
  if (kind !== 'white' && kind !== 'clear') { openDlChoice(); return; }
  const img = new Image(), data = saveZip();
  img.onload = () => data.then((z) => {
    const size = 800, canvas = document.createElement('canvas');
    canvas.width = canvas.height = size;
    const ctx = canvas.getContext('2d')!;
    if (kind === 'white') {
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, size, size);
    }
    ctx.drawImage(img, 0, 0, size, size);
    embedText(canvas, ctx, btoa(unescape(encodeURIComponent(z))));
    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob!), link = document.createElement('a');
      link.href = url;
      link.download = 'easy-peasy_' + randomName() + '.png';
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => { URL.revokeObjectURL(url); }, 60000); // すぐに消すと Safari で失敗することがある（本物と同じ）
    }, 'image/png');
  });
  img.src = $<HTMLImageElement>('chaMakeResultImageView').src;
}
export function openDlChoice() {
  if (!S.dlChoice) {
    S.dlChoice = document.createElement('div');
    S.dlChoice.className = 'emote-dl dl-choice';
    S.dlChoice.hidden = true;
    S.dlChoice.innerHTML =
      '<div class="emote-dl-card" role="dialog" aria-modal="true" aria-labelledby="dlChoiceTitle">' +
      '<h3 id="dlChoiceTitle">' + txtHtml('dl_title') + '</h3>' +
      '<button type="button" class="emote-dl-opt" data-kind="white"><span class="dl-sw" aria-hidden="true"></span><span>' + txtHtml('dl_white') + '</span></button>' +
      '<button type="button" class="emote-dl-opt" data-kind="clear"><span class="dl-sw dl-sw-clear" aria-hidden="true"></span><span>' + txtHtml('dl_clear') + '</span></button>' +
      '<p class="dl-note">' + txtHtml('dl_note') + '</p>' +
      '<button type="button" class="emote-dl-close">' + txtHtml('close') + '</button>' +
      '</div>';
    S.dlChoice.addEventListener('click', (e) => {
      if (e.target === S.dlChoice || (e.target as Element).closest('.emote-dl-close')) { S.dlChoice!.hidden = true; return; }
      const opt = (e.target as Element).closest('[data-kind]');
      if (!opt) return;
      S.dlChoice!.hidden = true;
      downloadFinished(opt.getAttribute('data-kind'));
    });
    S.dlChoice.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.stopPropagation(); S.dlChoice!.hidden = true; } });
    $('finish').appendChild(S.dlChoice);
  }
  S.dlChoice.hidden = false;
  S.dlChoice.querySelector<HTMLElement>('[data-kind]')!.focus({ preventScroll: true });
}
// 今のキャラの圧縮データ（Promise。画像に埋め込む・additional.js の高画質DL が埋め込む）
export function saveZip() { return zip(JSON.stringify(saveObject())); }
